var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.listTitle,
        "show-filter": true,
        "show-refresh": true,
        "show-extract": _vm.canExtract,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled":
          _vm.activateSpinnerVopHistory ||
          _vm.activateSpinnerVopMessage ||
          _vm.activateSpinnerVopResponse,
        "extract-disabled":
          _vm.activateSpinnerVopHistory ||
          _vm.activateSpinnerVopMessage ||
          _vm.activateSpinnerVopResponse,
      },
      on: {
        "toggle-filter": _vm.toggleFilterDisplay,
        refresh: _vm.refreshMessages,
        extract: _vm.exportMessages,
      },
    },
    [
      _c("template", { slot: "navigationTabs" }, [
        _c("div", { staticClass: "d-block d-lg-none" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c("app-button", {
                key: index,
                attrs: {
                  text: _vm.$t(tab.translationKey),
                  variant: _vm.tabName === index ? "primary" : "light",
                  size: "md",
                  block: true,
                  "custom-class": "mb-2",
                  "aria-pressed": _vm.tabName === index ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    _vm.tabName = index
                  },
                },
              })
            }),
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-lg-block" },
          [
            _c(
              "b-nav",
              { staticClass: "border-0", attrs: { tabs: "", fill: "" } },
              _vm._l(_vm.tabs, function (tab, index) {
                return _c(
                  "b-nav-item",
                  {
                    key: index,
                    class: { "bg-primary text-white": _vm.tabName === index },
                    attrs: { active: _vm.tabName === index },
                    on: {
                      click: function ($event) {
                        _vm.tabName = index
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t(tab.translationKey)) +
                        "\n        "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "filterContent" },
        [
          _c("app-panel", {
            attrs: {
              filters: _vm.filterConfig,
              searchAriaLabel:
                _vm.$t("common.srch") +
                " " +
                _vm.$t("common.monitoring.statistics"),
            },
            on: {
              "filter-changed": _vm.onFilterChanged,
              "clear-filters": _vm.clearFilterFields,
              "apply-filters": _vm.applyFilter,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-tabs",
                {
                  attrs: { "nav-class": "d-none" },
                  on: { input: _vm.onTabChange },
                  model: {
                    value: _vm.tabName,
                    callback: function ($$v) {
                      _vm.tabName = $$v
                    },
                    expression: "tabName",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t(
                          "common.monitoring.distribution_vop_response_status"
                        ),
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "justify-content-center mt-5" },
                        [
                          _vm.activateSpinnerVopResponse
                            ? _c("spinner")
                            : _vm.pieChartDataStatus
                            ? _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("h3", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.monitoring.distribution_vop_response_status"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("pie-chart", {
                                    ref: "pieChartStatus",
                                    attrs: {
                                      "chart-id": "pie-chart-status",
                                      "chart-data": _vm.pieChartDataStatus,
                                      options: _vm.chartOptionsStatus,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t(
                          "common.monitoring.time_distribution_by_processing_connector"
                        ),
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "justify-content-center mt-5" },
                        [
                          _vm.activateSpinnerVopHistory
                            ? _c("spinner")
                            : _vm.pieChartDataConnector
                            ? _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("h3", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.monitoring.time_distribution_by_processing_connector"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("pie-chart", {
                                    ref: "pieChartConnector",
                                    attrs: {
                                      "chart-id": "pie-chart-connector",
                                      "chart-data": _vm.pieChartDataConnector,
                                      options: _vm.chartOptionsConnector,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tab",
                    {
                      attrs: {
                        title: _vm.$t(
                          "common.monitoring.distribution_of_requests"
                        ),
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "justify-content-center mt-5" },
                        [
                          _vm.activateSpinnerVopMessage
                            ? _c("spinner")
                            : _vm.pieChartDataRequest
                            ? _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("h3", { staticClass: "text-center" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "common.monitoring.distribution_of_requests"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("pie-chart", {
                                    ref: "pieChartRequest",
                                    attrs: {
                                      "chart-id": "pie-chart-request",
                                      "chart-data": _vm.pieChartDataRequest,
                                      options: _vm.chartOptionsRequest,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.flagCACP
                    ? _c(
                        "b-tab",
                        {
                          attrs: {
                            title: _vm.$t(
                              "common.monitoring.average_duration_per_processing_step_messages"
                            ),
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "justify-content-center mt-5" },
                            [
                              _vm.activateSpinnerVopHistory
                                ? _c("spinner")
                                : _vm.lineChartData
                                ? _c(
                                    "b-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("h3", { staticClass: "text-center" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "common.monitoring.average_duration_per_processing_step_messages"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("line-chart", {
                                        ref: "lineChart",
                                        attrs: {
                                          "chart-id": "line-chart-duration",
                                          "chart-data": _vm.lineChartData,
                                          options: _vm.chartOptionsLine,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }